import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { LogOut, UserCircle } from 'lucide-react';
import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import styles from './Sidebar.module.css';

const SIGN_OUT = 'Sign out';
export const SidebarAccountMenu = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const name = [user?.firstName, user?.lastName].filter(Boolean).join(' ');
  const label = name || user?.email || 'Account';
  return (
    <DropdownMenu.Root open={open} onOpenChange={setOpen}>
      <DropdownMenu.Trigger asChild>
        <button className={styles.account} type="button" aria-label={label} title={label}>
          {user?.profilePictureUrl ? <img src={user.profilePictureUrl} alt="" /> : <UserCircle />}
          <span>
            <strong>{label}</strong>
            {name && <small>{user?.email}</small>}
          </span>
        </button>
      </DropdownMenu.Trigger>
      {open && (
        <DropdownMenu.Portal>
          <DropdownMenu.Content className={styles.accountMenu} side="right" align="end" sideOffset={8}>
            <DropdownMenu.Item className={styles.signOut} onSelect={logout}>
              <LogOut />
              {SIGN_OUT}
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      )}
    </DropdownMenu.Root>
  );
};
